import * as tslib_1 from "tslib";
import * as React from "react";
import createFocusTrap from "focus-trap";
export function useFocusElement(showing, options) {
  if (options === void 0) {
    options = {};
  }

  var elementRef = React.useRef(null);
  var trapRef = React.useRef(null);

  function focusElement() {
    if (!elementRef.current) {
      console.error("No element found to found");
      return;
    }

    var trap = createFocusTrap(elementRef.current, tslib_1.__assign({
      escapeDeactivates: false,
      clickOutsideDeactivates: true,
      fallbackFocus: '[tabindex="-1"]'
    }, options));
    trapRef.current = trap;
    trap.activate();
  }

  function focusTrigger() {
    if (!trapRef.current) {
      return;
    }

    trapRef.current.deactivate();
  }

  React.useEffect(function () {
    if (showing) focusElement();else focusTrigger();
  }, [showing]);
  return {
    bind: {
      ref: elementRef
    },
    focusElement: focusElement,
    focusTrigger: focusTrigger
  };
}